module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hr":{"title":"404","subtitle":"Stranica nije pronađena","message":"Traženi URL nije pronađen. Ta stranica je možda uklonjena ili premještena."},"en":{"title":"404","subtitle":"Page not found","message":"The requested URL was not found. The page might be deleted or removed. Please return to the home page."}}')
  delete Component.options._Ctor
}
